import { FINDER_KIND_NAMES } from "#ce/apps/SpFinder/kinds";
import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /** The kind of search the finder runs: a name `kinds/index.js` registers. @values provider, events */
  kind: {
    type: String,
    default: "provider",
    validator: (value) => FINDER_KIND_NAMES.includes(value),
  },

  /** Complete server embed scope, encoded as JSON in markup. @type {Object|String} */
  scope: {
    type: [Object, String],
    default: undefined,
  },

  /** Server open-scheduling configuration. @type {Boolean|String} */
  openScheduling: booleanAttribute(),

  /** Server passive-boost configuration. @type {Boolean|String} */
  passiveBoosts: booleanAttribute(),

  /** Scheduling slot presentation. */
  slotsUi: {
    type: String,
    default: undefined,
  },

  /** Server request locale. */
  locale: {
    type: String,
    default: undefined,
  },

  /**
   * The legacy provider finder's boot, as JSON in markup. Absent on the wrapper in the finder
   * template the embed loader fetches.
   * @type {Object|String}
   */
  boot: {
    type: [Object, String],
    default: undefined,
  },
});
